import { useHistory } from "react-router-dom";
import { observer } from "mobx-react";
import { Button, Grid } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import MonetaryField from "../../UI/Fields/MonetaryField";
import { PageHeader, PageTitle } from "../../UI/Page";
import { BackButton } from "../../UI/Buttons";

interface IProps {
  title: string;
  newButtonLabel: string;
  onNewData: (ev) => void;
  totals: {
    label: string;
    value: number;
  }[];
}

const InstallmentsPageHeader = observer(
  ({ title, newButtonLabel, onNewData, totals }: IProps) => {
    const history = useHistory();
    const handleClickBack = () => history.goBack();

    const total1 = totals[0];
    const total2 = totals[1];
    return (
      <PageHeader padding={[0, 1]}>
        <Grid container item xs justifyContent="flex-start">
          <BackButton onClick={handleClickBack} />
          <PageTitle>{title}</PageTitle>
        </Grid>
        <Grid container item xs={12} sm={10} md={8} justifyContent="flex-end">
          <Button
            variant="outlined"
            color="primary"
            startIcon={<AddIcon />}
            onClick={onNewData}
          >
            {newButtonLabel}
          </Button>
          <MonetaryField
            label={total1.label}
            value={total1.value}
            size="small"
            margin={[0, 0.25, 0, 1]}
          />
          <MonetaryField
            label={total2.label}
            value={total2.value}
            size="small"
            margin={[0, 0.25]}
          />
        </Grid>
      </PageHeader>
    );
  }
);

export default InstallmentsPageHeader;
